<div class="modal-header">
  <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close">
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">Change Ownership</h4>
</div>

<div class="modal-body">
  <div class="loading" *ngIf="loading" style="border-radius: 16px;">
    <div class="loader">Loading...</div>
  </div>

  <p>
    Select the new owner:
  </p>
  <!-- <select>
    <option *ngFor="let accountant of accountants">
      {{ accountant.user.full_name }}
    </option>
  </select> -->
  <p-dropdown [options]="accountants" [(ngModel)]="selectedNewOwner" optionLabel="user.full_name" showClear="true"
    placeholder="Select...">
  </p-dropdown>
  <div class="mt-3">
    <input type="checkbox" [disabled]="mandateChange" [(ngModel)]="setOnRepeatJobs"> Also set this user as the owner of Repeated Jobs
  </div>
</div>

<div class="modal-footer">
  <div class="btn btn-default pull-left" aria-label="Cancel" (click)="cancel()">
    Cancel
  </div>
  <div class="btn btn-primary pull-right" aria-label="Confirm" (click)="confirm()"
    [ngClass]="{'disabled': selectedNewOwner === null}">
    Change Ownership
  </div>
</div>